module.exports = __webpack_public_path__ + "img/10.e4a00b4f.jpg";